import { __ } from '@wordpress/i18n';

/**
 * Direct image imports (webpack / vite safe)
 */
import p1 from '../../assets/public/img/template/preview_1.webp';
import p2 from '../../assets/public/img/template/preview_2.webp';
import p3 from '../../assets/public/img/template/preview_3.webp';
import p4 from '../../assets/public/img/template/preview_4.webp';
import p5 from '../../assets/public/img/template/preview_5.webp';
import p6 from '../../assets/public/img/template/preview_6.webp';
import p7 from '../../assets/public/img/template/preview_7.webp';
import p8 from '../../assets/public/img/template/preview_8.webp';
import p9 from '../../assets/public/img/template/preview_9.webp';
import p10 from '../../assets/public/img/template/preview_10.webp';

import p11 from '../../assets/public/img/template/preview_12.webp';
import p12 from '../../assets/public/img/template/preview_11.webp';
import p13 from '../../assets/public/img/template/preview_13.webp';
import p14 from '../../assets/public/img/template/preview_14.webp';
import p15 from '../../assets/public/img/template/preview_15.webp';
import p16 from '../../assets/public/img/template/preview_16.webp';
import p17 from '../../assets/public/img/template/preview_17.webp';
import p18 from '../../assets/public/img/template/preview_18.webp';
import p19 from '../../assets/public/img/template/preview_19.webp';
import p20 from '../../assets/public/img/template/preview_20.webp';

import p21 from '../../assets/public/img/template/preview_21.webp';
import p22 from '../../assets/public/img/template/preview_22.webp';
import p23 from '../../assets/public/img/template/preview_23.webp';
import p24 from '../../assets/public/img/template/preview_24.webp';
import p25 from '../../assets/public/img/template/preview_25.webp';
import p26 from '../../assets/public/img/template/preview_26.webp';
import p27 from '../../assets/public/img/template/preview_27.webp';
import p28 from '../../assets/public/img/template/preview_28.webp';

/**
 * Style Config List
 */
const selectedStyle = [
  { value: 'style1', label: __('Style 1', 'cv-builder'), imageUrl: p1 },
  { value: 'style2', label: __('Style 2', 'cv-builder'), imageUrl: p2 },
  { value: 'style3', label: __('Style 3', 'cv-builder'), imageUrl: p3 },
  { value: 'style4', label: __('Style 4', 'cv-builder'), imageUrl: p4 },
  { value: 'style5', label: __('Style 5', 'cv-builder'), imageUrl: p5 },
  { value: 'style6', label: __('Style 6', 'cv-builder'), imageUrl: p6 },
  { value: 'style7', label: __('Style 7', 'cv-builder'), imageUrl: p7 },
  { value: 'style8', label: __('Style 8', 'cv-builder'), imageUrl: p8 },
  { value: 'style9', label: __('Style 9', 'cv-builder'), imageUrl: p9 },
  { value: 'style10', label: __('Style 10', 'cv-builder'), imageUrl: p10 },

  { value: 'style11', label: __('Style 11', 'cv-builder'), imageUrl: p11 },
  { value: 'style12', label: __('Style 12', 'cv-builder'), imageUrl: p13 },
  { value: 'style13', label: __('Style 13', 'cv-builder'), imageUrl: p15 },
  { value: 'style14', label: __('Style 14', 'cv-builder'), imageUrl: p17 },
  { value: 'style15', label: __('Style 15', 'cv-builder'), imageUrl: p18 },
  { value: 'style16', label: __('Style 16', 'cv-builder'), imageUrl: p19 },
  { value: 'style17', label: __('Style 17', 'cv-builder'), imageUrl: p20 },
  { value: 'style18', label: __('Style 18', 'cv-builder'), imageUrl: p21 },
  { value: 'style19', label: __('Style 19', 'cv-builder'), imageUrl: p22 },
  { value: 'style20', label: __('Style 20', 'cv-builder'), imageUrl: p23 },

  { value: 'style21', label: __('Style 21', 'cv-builder'), imageUrl: p24 },
  { value: 'style22', label: __('Style 22', 'cv-builder'), imageUrl: p25 },
  { value: 'style23', label: __('Style 23', 'cv-builder'), imageUrl: p12 },
  { value: 'style24', label: __('Style 24', 'cv-builder'), imageUrl: p14 },
  { value: 'style25', label: __('Style 25', 'cv-builder'), imageUrl: p16 },

  { value: 'style26', label: __('Style 26', 'cv-builder'), imageUrl: p26, isAts: true },
  { value: 'style27', label: __('Style 27', 'cv-builder'), imageUrl: p27, isAts: true },
  { value: 'style28', label: __('Style 28', 'cv-builder'), imageUrl: p28, isAts: true },
];

export default selectedStyle;
